import React, {useEffect} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {withNamespaces} from 'react-i18next';

function Input({t, ref, type, id, error, info, label, value, disabled, onChange, placeholder, className, tooltipInfo, multiple, disablePasting}) {
  useEffect(() => {
    if (tooltipInfo) {
      window.$('[data-toggle="tooltip"]').tooltip();
    }
  }, [tooltipInfo]);

  className = `${type === 'file' ? 'form-control-file' : 'form-control'} ${error ? 'is-invalid' : ''} ${className ? className : ''}`;  

  const labelEl = label !== false
    ? (
      <label htmlFor={id}>
        {t('form.' + id + '.label')}
        
        {
          tooltipInfo
            ? (
              <span
                data-toggle="tooltip"
                data-placement="right"
                title={tooltipInfo}
                style={{marginLeft: '.5rem', paddingRight: '.7rem'}}
              >
                <FontAwesomeIcon
                  icon={'question-circle'}
                />
              </span>
            )
            : null
        }
      </label>
    )
    : null;
  
  const infoEl = info
      ? (
        <small class="form-text text-muted">
          {info} 
        </small>
      )
      : null;

  return (
    <div className="mb-4">
      {labelEl}
      
      <input
        ref={ref}
        type={type}
        name={id}
        id={id}
        className={className}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        multiple={multiple}
        onPaste={disablePasting ? e => e.preventDefault() : null}
      />

      {infoEl}
      
      <div className="invalid-feedback">
        {error}
      </div>
    </div>
  );
}

export default withNamespaces()(Input);